import {React,useEffect} from 'react'
import { Link } from 'react-router-dom';
import { fetchCategory } from "../../features/news/NewsSlice";
import { useDispatch, useSelector } from "react-redux";

const NewsNavbar = () => {
  const {category } = useSelector((state) => state.news);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategory());
  }, [dispatch]);
  console.log("first",category)
  return (
    <div className="animation font-Laila sticky overflow-x-auto mx-auto border-b-2 border-primary-red flex-shrink-0  top-[3.8rem] z-30  items-center gap-3 bg-white py-1  md:py-3 lg:top-[7.6rem] lg:justify-center">
    <div className="flex  justify-center mx-auto  overflow-scroll no-scrollbar gap-6">
      {category.map((items, index) => {
        
        return (
          <div className='font-Laila news-button' key={index}>
          <Link 
         
          state={{
            id: items.id,
            name:items.name_eng
          }}   
          to={`${items.name_eng}`}
                      // to="/news/category"
                     
          key={index} className="">
            {items.name_nep}
          </Link>
          </div>
        );
      })}
    </div>
  </div>
  )
}

export default NewsNavbar